import { cn } from '@/lib/utils';
import { SidebarHeader } from './sidebar/SidebarHeader';
import { SidebarNav } from './sidebar/SidebarNav';

interface SidebarProps {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  mobileOpen: boolean;
  setMobileOpen: (open: boolean) => void;
}

export function Sidebar({ collapsed, setCollapsed, mobileOpen, setMobileOpen }: SidebarProps) {
  return (
    <>
      {/* Mobile backdrop */}
      <div
        className={cn(
          'fixed inset-0 z-50 bg-gray-900/60 dark:bg-gray-950/80 backdrop-blur-sm lg:hidden',
          mobileOpen ? 'block' : 'hidden'
        )}
        onClick={() => setMobileOpen(false)}
      />

      {/* Sidebar */}
      <div
        className={cn(
          'sidebar fixed inset-y-0 left-0 z-50 border-r',
          'transition-all duration-300 ease-in-out',
          collapsed ? 'w-16' : 'w-64',
          mobileOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
        )}
      >
        <SidebarHeader 
          collapsed={collapsed}
          onCollapse={() => setCollapsed(!collapsed)}
          onMobileClose={() => setMobileOpen(false)}
        />
        <div className="py-3">
          <SidebarNav collapsed={collapsed} />
        </div>
      </div>
    </>
  );
}
